export default __webpack_public_path__ + "static/media/calendar-dayoff.bdc968a4.svg";